module.exports = __webpack_public_path__ + "static/img/kcp1.d578d0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/kcp1.jpg
// module id = KGgb
// module chunks = 0